// CountrySelector.js
import React from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";
import { countryCodesSelector } from "../store/selectors/app.selector";

export default function CountrySelector({ selectedCountryCode, onChange }) {
  const countryList = useSelector(countryCodesSelector);

  const handleChange = (value) => {
    const selected = countryList.find((e) => e.isdCode === value);
    onChange(selected);
  };

  return (
    <Select
      value={`+${selectedCountryCode}`}
      className="custom-select"
      style={{ width: 90 }}
      onChange={handleChange}
      filterOption={
        (input, option) =>
          option.children[0].props.children.includes(input) ||
          option.children[2].props.children
            .toLowerCase()
            .includes(input.toLowerCase())
      }
      showSearch
    >
      {countryList.map((option, idx) => (
        <Select.Option
          key={idx}
          value={option.isdCode}
          title={option.countryName}
        >
          <span>{`+${option.isdCode}`}</span>
          {/* <br />
          <span style={{ fontSize: "12px" }}>{option.countryName}</span> */}
        </Select.Option>
      ))}
    </Select>
  );
}
